import type { RevitFamily } from '../../../api/revit/types';
import { familyHasCompatibleParameter } from '../../revit/familyParameterTargetSelection';

export function familyHasParameter(
  family: RevitFamily,
  parameterName: string,
): boolean {
  return familyHasCompatibleParameter(family, parameterName);
}

export function familyMatchesAnyObjectType(
  family: RevitFamily,
  targetObjectTypes: string[],
  objectTypeParameterName: string,
  bindingKind?: 'type' | 'instance',
): boolean {
  const normalizedParameterName = objectTypeParameterName.trim().toUpperCase();
  const normalizedTargets = new Set(
    targetObjectTypes.map((objectType) => objectType.trim().toUpperCase())
      .filter(Boolean),
  );

  if (!normalizedParameterName || normalizedTargets.size === 0) {
    return false;
  }

  return Array.isArray(family?.types) &&
    family.types.some((familyType: any) =>
      Array.isArray(familyType?.parameterValues) &&
      familyType.parameterValues.some((parameterValue: any) => {
        const parameterName = (parameterValue?.parameterName || '').trim()
          .toUpperCase();
        const parameterValueText = String(parameterValue?.value ?? '').trim()
          .toUpperCase();
        if (!parameterName || !parameterValueText) {
          return false;
        }

        // Classification is written on the configured binding route, so only
        // evidence of that kind proves the match: an instance-bound
        // discriminator is invisible on type rows (and vice versa), and
        // counting the wrong kind matches families the write path will not.
        if (bindingKind &&
          Boolean(parameterValue?.isInstance) !== (bindingKind === 'instance')) {
          return false;
        }

        return parameterName === normalizedParameterName &&
          normalizedTargets.has(parameterValueText);
      })
    );
}
